import {
    getCurrentStartAndEndOfWeek,
    normalizeIso8601DateOnly
} from '@libs/dateTime';

import { ADMIN_TIMESHEET_INTITAL_API_PARAMS } from './Timesheet/common';

export const ATTENDANCE = 'timeAndAttendance@allAttendance';
export const DAILY_ALL_ATTENDANCE = '@dailyAllAttendance';
export const WEEKLY_ALL_ATTENDANCE = '@weeklyAllAttendance';
export const MONTHLY_ALL_ATTENDANCE = '@monthlyAllAttendance';
export const YEARLY_ALL_ATTENDANCE = '@yearlyAllAttendance';
export const MY_DAILY_ATTENDANCE = '@myDailyAttendance';
export const MY_WEEKLY_ATTENDANCE = '@myWeeklyAttendance';
export const MY_MONTHLY_ATTENDANCE = '@myMonthlyAttendance';
export const MY_YEARLY_ATTENDANCE = '@myYearlyAttendance';
export const RANGE_ALL_ATTENDANCE = '@rangeAllAttendance';

const timeAndAttendanceDatasets = {
    [DAILY_ALL_ATTENDANCE]: {
        url: 'attendance/get-all-daily-attendances',
        /*
         * scope=team asks the API to narrow this to the caller's own reports
         * when they are a line manager. The flag is needed because the
         * dashboard hits this same endpoint to list who is in today, for the
         * whole company -- so the server cannot tell the two views apart
         * unless the timesheet says which one it is.
         *
         * It belongs on this dataset rather than on
         * ADMIN_TIMESHEET_INTITAL_API_PARAMS, which the dashboard-facing and
         * range datasets also read.
         */
        params: { ...ADMIN_TIMESHEET_INTITAL_API_PARAMS, scope: 'team' },
        selector: () => false,
        dataGrid: true
    },
    [WEEKLY_ALL_ATTENDANCE]: {
        url: 'attendance/get-all-weekly-attendances',
        params: {
            ...getCurrentStartAndEndOfWeek(),
            pageSize: 10
        },
        selector: () => false,
        dataGrid: true
    },
    [MONTHLY_ALL_ATTENDANCE]: {
        url: 'attendance/get-all-monthly-attendances',
        params: {
            pageSize: 10,
            year: new Date().getFullYear(),
            month: new Date().getMonth() + 1
        },
        selector: () => false,
        dataGrid: true
    },
    [YEARLY_ALL_ATTENDANCE]: {
        url: 'attendance/get-yearly-attendance',
        params: {
            pageSize: 10,
            year: new Date().getFullYear(),
            month: new Date().getMonth() + 1
        },
        selector: () => false,
        dataGrid: true
    },
    [MY_DAILY_ATTENDANCE]: {
        url: 'attendance/my-attendance',
        params: {
            from: normalizeIso8601DateOnly(),
            to: normalizeIso8601DateOnly()
        },
        selector: () => false,
        dataGrid: true
    },
    [MY_WEEKLY_ATTENDANCE]: {
        url: 'attendance/weekly-status',
        params: {
            ...getCurrentStartAndEndOfWeek()
        },
        selector: () => false,
        dataGrid: true
    },
    [MY_MONTHLY_ATTENDANCE]: {
        url: 'attendance/monthly-status',
        params: {
            year: new Date().getFullYear(),
            month: new Date().getMonth() + 1
        },
        selector: () => false,
        dataGrid: true
    },
    [MY_YEARLY_ATTENDANCE]: {
        url: 'attendance/yearly-status',
        params: {
            year: new Date().getFullYear()
        },
        selector: () => false,
        dataGrid: true
    },
    [RANGE_ALL_ATTENDANCE]: {
        url: 'attendance/get-attendances-by-date-range',
        method: 'GET',
        params: ADMIN_TIMESHEET_INTITAL_API_PARAMS,
        selector: () => false,
        dataGrid: true
    }
};

export default timeAndAttendanceDatasets;
